import React from 'react';
import { createUseStyles } from 'react-jss';

interface BlockSelectorProps {
  label?: string;
  theme?: string;
  required?: boolean;
  options: {
    label: string;
    value: string;
  }[];
  value?: string;
  callback?: (value: any) => void;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  gap?: number;
}

function BlockSelector({
  label,
  theme,
  required,
  options,
  value,
  callback,
  className,
  style,
  disabled,
  gap = 10,
}: BlockSelectorProps) {
  const useStyles = createUseStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    },
    blockSelector: {
      display: 'flex',
      alignItems: 'center',
      gap: `${gap}px`,
      '&.theme-tab': {
        gap: '0px !important',
      },
    },
    btn: {
      fontSize: '16px',
      fontWeight: 'bold',
      cursor: 'pointer',
      padding: '8px 20px',
      border: '1px solid #ccc',
      color: '#000000',
      backgroundColor: 'transparent',
      borderRadius: '4px',
      width: '100%',
      '&:hover': {
        borderColor: 'var(--dai-primary-color)',
        backgroundColor: 'transparent',
      },
      '&.active': {
        backgroundColor: 'var(--dai-primary-color)',
        borderColor: 'var(--dai-primary-color)',
        color: 'white',
      },
      '&:focus': {
        outline: '1px solid var(--dai-primary-color)',
      },
      '&.theme-tab': {
        width: '100%',
        border: '0',
        borderRadius: '0',
        backgroundColor: 'transparent',
        borderBottom: '1px solid #ccc',
        padding: '0px 15px 15px',
        color: '#666',
        position: 'relative',
        '&.active': {
          borderColor: 'var(--dai-primary-color)',
          color: 'var(--dai-primary-color)',
          '&:after': {
            content: '""',
            position: 'absolute',
            left: '0',
            bottom: '0',
            width: '100%',
            height: '2px',
            backgroundColor: 'var(--dai-primary-color)',
          },
        },
      },
    },
    label: {
      fontSize: '14px',
      fontWeight: 'bold',
      '& .required': {
        color: '#FF0000',
        marginLeft: '4px',
      },
    },
  });

  const classes = useStyles();

  return (
    <div className={`${classes.container}`} style={style}>
      {label && (
        <div className={classes.label}>
          {label}
          {required && <span className="required">*</span>}
        </div>
      )}
      <div className={`${classes.blockSelector} theme-${theme}`} style={style}>
        {options.map((option) => (
          <button
            key={option.value}
            className={`${classes.btn} ${className} theme-${theme} ${
              value === option.value ? 'active' : ''
            }`}
            onClick={() => callback && callback(option.value)}
            disabled={disabled}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default BlockSelector;
